import { render, staticRenderFns } from "./daHuoList.vue?vue&type=template&id=fd39dc3a&scoped=true&"
import script from "./daHuoList.vue?vue&type=script&lang=js&"
export * from "./daHuoList.vue?vue&type=script&lang=js&"
import style0 from "./daHuoList.vue?vue&type=style&index=0&id=fd39dc3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd39dc3a",
  null
  
)

export default component.exports